<template>
  <b-modal
      id="1"
      :title="title"
      v-model="isOpenLocal"
      size="lg"
      scrollable
      :hide-footer="hideFooter"
      :ok-title="capitalize($t('validate'))"
      :cancel-title="capitalize($t('cancel'))"
      @hide="tryCloseIncomingInvoiceModal"
      @hidden="handleCancel"
      @ok="handleOk"
  >
    <validation-observer
        ref="observerRef"
        #default="{handleSubmit, errors}">
      <b-form @submit.prevent="handleSubmit(submitValidatedIncomingInvoiceLocal)">
        <form-incoming-invoice
            :invoice="incomingInvoiceLocal"
            :formErrors="errors"
        />
        <button ref="submitIncomingInvoiceFormRef"
                class="d-none"></button>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { ValidationObserver } from 'vee-validate'
import { capitalize } from '../../utils/filter'

import useAPI from '../../utils/useAPI'
import FormIncomingInvoice from '../form/incomingInvoice/IncomingInvoice'

export default {
  components: {
    ValidationObserver,
    FormIncomingInvoice
  },
  props: {
    incomingInvoice: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------
    const isOpenLocal = ref(false)
    const incomingInvoiceLocal = ref(props.incomingInvoice)
    const submitIncomingInvoiceFormRef = ref(null)
    const observerRef = ref(null)

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const { currentBreakPoint } = useAPI()

    const hideFooter = computed(() => {
      return !['xs', 'sm'].includes(currentBreakPoint.value)
    })

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------
    watch(isOpenLocal, (val) => {
      emit('update:isOpen', val)
    })
    watch(incomingInvoiceLocal, (val) => {
      emit('update:incomingInvoice', val)
    })

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------
    const tryCloseIncomingInvoiceModal = (modalEvent) => {
      if (modalEvent.trigger == 'backdrop') {
        // Click outside
        modalEvent.preventDefault()
        submitIncomingInvoiceFormRef.value.click()
      }
    }

    const submitValidatedIncomingInvoiceLocal = () => {
      emit('submitValidatedIncomingInvoice')
    }

    const handleOk = async (bvModalEvent) => {
      bvModalEvent.preventDefault()

      const isValid = await observerRef.value.validate()
      if (isValid) {
        submitValidatedIncomingInvoiceLocal()
      }
    }

    const handleCancel = () => {}

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components
      capitalize,

      // Data
      isOpenLocal,
      incomingInvoiceLocal,
      submitIncomingInvoiceFormRef,
      observerRef,

      // Computed
      hideFooter,

      // Methods
      tryCloseIncomingInvoiceModal,
      submitValidatedIncomingInvoiceLocal,
      handleOk,
      handleCancel,
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {
    incomingInvoice: function (val) {
      this.incomingInvoiceLocal = val
    },
    isOpen: function (val) {
      this.isOpenLocal = val
    }
  },
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>